import React, { useContext, useEffect, useState } from 'react';
import { v4 } from 'uuid';

import { TBannerProps } from '@riac/design-system';
import { GlobalBannerContext } from 'src/lib/GlobalBannerContext';


export type GlobalBannerProps = TBannerProps;

export const GlobalBanner = (props: GlobalBannerProps): JSX.Element => {
  const [id] = useState<string>(v4());
  const {addBanner, removeBanner} = useContext(GlobalBannerContext);

  useEffect(() => {
    addBanner(props, id);

    return () => {
      removeBanner(id);
    };
  }, [...Object.values(props)]);

  return <></>;
};
